<template>
	<div :class="containerClass" @click="onWrapperClick">
        <ToastManager />
        <AppTopBar @menu-toggle="onMenuToggle" />
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>

        <div class="layout-main-container">
            <div class="layout-main shadow-4">
                <router-view/>
            </div>
        </div>

        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
	</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';

import ToastManager from '@/components/ToastManager.vue';

import { buildMenuBasedOnRole } from './js_utilities/menuUtils.js'

export default {
    emits: ['change-theme'],
    data() {
        return {
            layoutMode: 'static',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            // this.$toast.removeAllGroups();
        }
    },
    methods: {

        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$primevue.config.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.config.ripple === false
            }];
        },
        logo() {
            return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
        }
    },
    beforeUpdate() {
        this.addClass(document.body, 'body-overflow-hidden');
        // if (this.mobileMenuActive)
        //     this.addClass(document.body, 'body-overflow-hidden');
        // else
        //     this.removeClass(document.body, 'body-overflow-hidden');
    },

    async beforeCreate() {
        let loggedIn_user_id = this.$store.getters.getLoggedInUser.uuid
        let userRole = this.$store.getters.getLoggedInUser.role.name

        this.menu = buildMenuBasedOnRole(userRole)

        this.$store.dispatch('updateNotificationsFromDb', loggedIn_user_id)

        if (userRole === "admin") {
            await this.$store.dispatch('updateQualificationsFromDb');
            await this.$store.dispatch('updateSexesFromDb');
            await this.$store.dispatch('updateRolesFromDb');
            await this.$store.dispatch('updateTeamsFromDb');
            await this.$store.dispatch('updateTeamFunctionsFromDb');
            await this.$store.dispatch('updateDepartmentsFromDb');
            await this.$store.dispatch('updateLocationsFromDb');
            await this.$store.dispatch('updateShiftRhythmsFromDb');
            await this.$store.dispatch('updateEmployeesFromDb');
            await this.$store.dispatch('updateEmployeesFromDb', { loadDeleted: true });
        }
    },

    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'ToastManager': ToastManager
        // 'AppConfig': AppConfig,
        // 'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
